import useSWR from 'swr';
import { useRef } from 'react';
import type { SwrReturnType } from '~/models/Api';
import { convertQueryStringUrl } from '~/utils/DealSearchConditionUtils';
import type {
  CompanyDealDashboard,
  DealDashboardCondition
} from '~/models/DealDashboard';

const paths = {
  index: '/homes'
};

export const useHomes = (
  query: DealDashboardCondition
): SwrReturnType<CompanyDealDashboard> => {
  const cachedDataRef = useRef<CompanyDealDashboard | null>(null);
  const { data, mutate, error, isLoading } = useSWR<CompanyDealDashboard>(
    convertQueryStringUrl(paths.index, query)
  );

  if (data) {
    cachedDataRef.current = data;
  }

  return {
    data: data ?? cachedDataRef.current,
    mutate,
    isLoading,
    error
  };
};
